export default function shuffleAnswers( answers ) {
    
    //move open answer aside:
    let openAns;
    for(let i=0; i<answers.length; i++){
        if(answers[i].isOpen) {
            openAns = answers[i];
            answers.splice(i,1);
        }
    }

    let currentIndex = answers.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      temporaryValue = answers[currentIndex];
      answers[currentIndex] = answers[randomIndex];
      answers[randomIndex] = temporaryValue;
    }

    if(openAns) answers.push(openAns);

    return answers;
    
}


// WEBPACK FOOTER //
// ./src/Utils/ShuffleAnswers.js